export const REVIEWS_ANCHOR = "bewertungen";

export const SCROLL_MARGIN = "scroll-mt-[80px]";
